export { ja } from '@payloadcms/translations/languages/ja'
